var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();return _vm.$emit('enter')},function($event){return _vm.$emit('keyup')}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }